"use strict";

exports.__esModule = true;
exports.getMetricFilterTypeDefinition = getMetricFilterTypeDefinition;
exports.metricFilterDefinitions = void 0;
var metricFilterDefinitions = exports.metricFilterDefinitions = [{
  name: "range",
  label: "between",
  description: "Filter by range."
}, {
  name: "terms",
  label: "one of",
  description: "Filter by terms."
}, {
  name: "term",
  label: "equal to",
  description: "Filter by term."
}];

/**
 * Get the definition for the metric filter with the given name.
 */
function getMetricFilterTypeDefinition(name) {
  for (var i = 0; i < metricFilterDefinitions.length; i++) {
    var definition = metricFilterDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown metric filter type: " + name);
}